import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

import { getUserData, getPollResultsAllChoice } from '../../../../shared/redux/selectors';
import { getProposedChanges } from '../../helpers/constitutionResults';
import Image from '../../../../shared/components/Image';
import ImageManifest from '../../../../assets/images/constitution/A4_manifest.png';
import List from '../../../../shared/components/List';
import Paragraph from '../../../../shared/components/Paragraph';
import Separator from '../../../../shared/structure/Separator';
import VoiceLink from '../../../../shared/components/Link';

function MailContent({
  allData, state, userData,
}) {
  const { t } = useTranslation();

  function getCurrentDate() {
    const newDate = new Date();
    const date = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();

    return `${date}.${month < 10 ? `0${month}` : `${month}`}.${year}`;
  }

  const proposedChanges = getProposedChanges(state === 'all' ? allData : userData);
  const ProposedChangesList = proposedChanges && (
    <List numbered>
      {proposedChanges && proposedChanges.map((key) => (
        <li key={key}>
          {t(key)}
          <Box pb={2} />
        </li>
      ))}
    </List>
  );

  return (
    <>
      <Paragraph
        title={t('mail_mail_body_title')}
      />
      <Paragraph textAlign="right">
        {t('mail_header_p_1')}
        <br />
        {t('mail_header_p_2')}
        <br />
        {t('mail_header_p_3')}
      </Paragraph>

      <Paragraph>
        {t('mail_body_p_1_1')}
        <strong>______________________________</strong>
        {t('mail_body_p_1_2')}
      </Paragraph>

      <Paragraph
        title={t('mail_body_block_1_title')}
      >
        {t('mail_body_block_1_p_1')}
      </Paragraph>
      <Paragraph>
        {t('mail_body_block_1_p_2')}
        <VoiceLink
          target="_blank"
          href="http://bit.ly/golos-final-report"
          underline="always"
        >
          http://bit.ly/golos-final-report.
        </VoiceLink>
      </Paragraph>
      <Paragraph>
        {t('mail_body_block_1_p_3')}
      </Paragraph>
      <List numbered>
        <li>
          {t('mail_body_block_1_p_3_item1')}
        </li>
        <br />
        <li>
          {t('mail_body_block_1_p_3_item2')}
        </li>
        <br />
        <li>
          {t('mail_body_block_1_p_3_item3')}
        </li>
      </List>
      <Paragraph>
        {t('mail_body_block_1_p_4')}
      </Paragraph>

      <Paragraph
        title={t('mail_body_block_2_title')}
      >
        {t('mail_body_block_2_p_1')}
      </Paragraph>

      {ProposedChangesList}

      <Paragraph
        title={t('mail_body_block_3_title')}
      >
        {t('mail_body_block_3_p_1')}
      </Paragraph>
      <Paragraph>
        {t('mail_body_block_3_p_2')}
      </Paragraph>

      <Separator />

      <Paragraph>
        {t('mail_footer_p_1')}
      </Paragraph>
      <Paragraph>
        ______________________________
        <br />
        {t('mail_footer_p_2')}
        ______________________________
      </Paragraph>
      <Separator />
      <Paragraph>
        {getCurrentDate()}
      </Paragraph>

      <Image
        src={ImageManifest}
        fullWidth
        alt={t('mail_mail_body_title')}
      />
    </>
  );
}

MailContent.defaultProps = {
  allData: null,
  state: 'all',
  userData: null,
};

MailContent.propTypes = {
  state: PropTypes.oneOf(['my', 'all']),
  userData: PropTypes.objectOf(PropTypes.any),
  allData: PropTypes.objectOf(PropTypes.any),
};

const mapStateToProps = (state) => ({
  userData: getUserData(state),
  allData: getPollResultsAllChoice(state),
});

export default connect(mapStateToProps)(MailContent);
